import { QueryClient } from '@tanstack/react-query'
import * as Sentry from '@sentry/react'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      onError: (error) => {
        Sentry.captureException(error)
      },
    },
  },
})

export default queryClient
